import { render, staticRenderFns } from "./donate-pay.vue?vue&type=template&id=0c086422&"
import script from "./donate-pay.vue?vue&type=script&lang=js&"
export * from "./donate-pay.vue?vue&type=script&lang=js&"
import style0 from "./donate-pay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports